var _rect, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#61B510"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 32,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 27,
    fontWeight: 700,
    fill: "#FFFFFF",
    textAnchor: "middle",
    dominantBaseline: "central",
    letterSpacing: 0.5
  }, "DK")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDkIcon);
export default __webpack_public_path__ + "static/media/dk_icon.d01761ce65f0369b3d77c489148a4ac3.svg";
export { ForwardRef as ReactComponent };